<template>
  <div
    v-if="token"
    class="floating-ball"
    :style="{ left: posX + 'px', top: posY + 'px' }"
    @mousedown="onMouseDown"
    @click="onClick"
  >
    <div class="ball-inner">
      <slot>
        <span class="ball-text">商家<br>指南</span>
      </slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FloatingBall',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  },
  computed: {
    ...mapGetters(['token'])
  },
  watch: {
    token(val) {
      if (val) {
        this.$nextTick(() => {
          const w = this.$el.offsetWidth
          const h = this.$el.offsetHeight
          this.posX = window.innerWidth - w - 20
          this.posY = window.innerHeight - h - 20
        })
      }
    }
  },
  data() {
    return {
      posX: 20,
      posY: 200,
      dragging: false,
      startX: 0,
      startY: 0,
      startPosX: 0,
      startPosY: 0,
      moved: false
    }
  },
  mounted() {
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('mouseup', this.onMouseUp)
    if (this.token) {
      this.$nextTick(() => {
        const w = this.$el.offsetWidth
        const h = this.$el.offsetHeight
        this.posX = window.innerWidth - w - 20
        this.posY = window.innerHeight - h - 20
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('mouseup', this.onMouseUp)
  },
  methods: {
    onMouseDown(e) {
      this.dragging = true
      this.moved = false
      this.startX = e.clientX
      this.startY = e.clientY
      this.startPosX = this.posX
      this.startPosY = this.posY
    },
    onMouseMove(e) {
      if (!this.dragging) return
      const dx = e.clientX - this.startX
      const dy = e.clientY - this.startY
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) this.moved = true
      const el = this.$el
      const maxX = window.innerWidth - el.offsetWidth
      const maxY = window.innerHeight - el.offsetHeight
      this.posX = Math.min(Math.max(this.startPosX + dx, 0), maxX)
      this.posY = Math.min(Math.max(this.startPosY + dy, 0), maxY)
    },
    onMouseUp() {
      this.dragging = false
    },
    onClick() {
      if (this.moved) return
      this.handleClick()
    },
    handleClick() {
      window.open('https://file.dljiujiu.top/help/UserManual.pdf', '_blank')
    }
  }
}
</script>

<style scoped>
.floating-ball {
  position: fixed;
  z-index: 9999;
  width: 56px;
  height: 56px;
  cursor: grab;
  user-select: none;
}
.floating-ball:active {
  cursor: grabbing;
}
.floating-ball:hover .ball-inner {
  transform: scale(1.08);
  box-shadow: 0 6px 20px rgba(64, 158, 255, 0.6);
}
.ball-inner {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(135deg, #409eff, #36b5ff);
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: transform 0.2s, box-shadow 0.2s;
  pointer-events: none;
}
.ball-text {
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
}
</style>